import React from "react";
import { Autocomplete, TextField, Checkbox, Button, Chip } from "@mui/material";

const ValueBookiesFilter = ({
  bookmakers,
  selectedBookmakers,
  onBookmakersChange,
}) => {
  const bookmakerOptions = Object.keys(bookmakers);

  const handleSelectAllToggle = () => {
    if (selectedBookmakers.length === bookmakerOptions.length) {
      onBookmakersChange([]);
    } else {
      onBookmakersChange(bookmakerOptions);
    }
  };

  const renderTags = (value, getTagProps) =>
    value.length > 2
      ? [
          ...value
            .slice(0, 2)
            .map((option, index) => (
              <Chip
                key={option}
                {...getTagProps({ index })}
                label={option}
                size="small"
              />
            )),
          <Chip key="more" label={`+${value.length - 2} more`} size="small" />,
        ]
      : value.map((option, index) => (
          <Chip
            key={option}
            {...getTagProps({ index })}
            label={option}
            size="small"
          />
        ));

  return (
    <Autocomplete
      multiple
      sx={{ width: "100%" }}
      options={bookmakerOptions}
      value={selectedBookmakers}
      onChange={(event, newValue) => onBookmakersChange(newValue)}
      disableCloseOnSelect
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option}
        </li>
      )}
      renderTags={renderTags}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Bookmakers"
          placeholder="Select bookmakers"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {params.InputProps.endAdornment}
                {selectedBookmakers.length !== bookmakerOptions.length && (
                  <Button onClick={handleSelectAllToggle}>All</Button>
                )}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ValueBookiesFilter;
